import styled from "styled-components"
import theme from "../../theme"

const ModalCardTitle = styled<any, "header">("header")`
  color: ${theme.colors.modalText};
  background: ${theme.colors.modalBody};
  flex-grow: 1;
  flex-shrink: 0;
  font-size: 1.5rem;
  line-height: 1;
  @media screen and (max-width: 481px) {
    font-size: 1.25rem;
  }
`

export default ModalCardTitle
